var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#C83E44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66528 13.1868L5.94718 10.485C5.87123 10.4091 5.83325 10.3114 5.83325 10.192C5.83325 10.0727 5.87123 9.97504 5.94718 9.89908L6.5494 9.31315C6.62535 9.22634 6.72029 9.18294 6.83423 9.18294C6.94816 9.18294 7.04853 9.22634 7.13533 9.31315L8.95824 11.1361L12.8645 7.22982C12.9513 7.14301 13.0517 7.09961 13.1656 7.09961C13.2795 7.09961 13.3745 7.14301 13.4504 7.22982L14.0526 7.81575C14.1286 7.89171 14.1666 7.98936 14.1666 8.10872C14.1666 8.22808 14.1286 8.32573 14.0526 8.40169L9.25121 13.1868C9.17526 13.2736 9.0776 13.317 8.95824 13.317C8.83889 13.317 8.74123 13.2736 8.66528 13.1868Z",
    fill: "#C83E44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesIcon);
export default __webpack_public_path__ + "static/media/yes-icon.b1980b9da4e2cd80f5e7186c4eb2edff.svg";
export { ForwardRef as ReactComponent };